import { HttpErrorResponse } from '@angular/common/http';

export interface AtlasRequestErrorMessageOptions {
  fallbackMessage: string;
  statusMessage?: string;
  includeStatusWithFallback?: boolean;
  statusMessages?: { [status: number]: string };
}

export function extractErrorDetail(errorBody: unknown): string | null {
  console.log(errorBody);

  if (!errorBody) {
    return null;
  }

  if (typeof errorBody === 'string') {
    return errorBody.trim() || null;
  }

  if (Array.isArray(errorBody)) {
    const messages = errorBody
      .map(item => extractErrorDetail(item))
      .filter(Boolean) as string[];
    return messages.length ? messages.join(' ') : null;
  }

  if (typeof errorBody === 'object') {
    const body = errorBody as { detail?: unknown; message?: unknown; loc?: unknown; msg?: unknown };
    console.log(body);
    if (body.detail) {
      return extractErrorDetail(body.detail);
    }

    if (typeof body.message === 'string' && body.message.trim()) {
      return body.message.trim();
    }

    if (typeof body.msg === 'string' && body.msg.trim()) {
      const location = Array.isArray(body.loc) ? body.loc.join('.') : '';
      return location ? `${location}: ${body.msg.trim()}` : body.msg.trim();
    }
  }

  return null;
}

export function formatAtlasRequestErrorMessage(
  error: unknown,
  options: AtlasRequestErrorMessageOptions
): string {
  if (!(error instanceof HttpErrorResponse)) {
    return options.fallbackMessage;
  }

  const statusMessage = options.statusMessages?.[error.status];
  if (statusMessage) {
    return statusMessage;
  }

  const detail = extractErrorDetail(error.error);
  const messagePrefix = options.statusMessage
    ? `${options.statusMessage} (${error.status}).`
    : options.includeStatusWithFallback
      ? `${options.fallbackMessage} (${error.status}).`
      : options.fallbackMessage;

  return detail ? `${messagePrefix} ${detail}` : messagePrefix;
}
